import {Component, ElementRef, Input, Renderer2} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'cp-entire',
    templateUrl: 'cp-entire.html',
    providers: []
})
export class CpEntire {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;

    constructor(public element: ElementRef, private renderer: Renderer2) {

    }

    ngOnInit() {

        this.renderer.addClass(this.element.nativeElement, 'display-block');
        //this.renderer.addClass(this.element.nativeElement, 'position-relative');
        //this.renderer.addClass(this.element.nativeElement, 'z-index-1');
        // this.renderer.addClass(this.element.nativeElement, 'centro-1300');

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/cp-entire/cp-entire.ts